import httpClient from '@/http-client'

export const getStudents = (Options = {}) => {
  return httpClient
    .get('/api/student-score-delete-by-session/students', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getAcademicStatuses = (Options = {}) => {
  return httpClient
    .get('/api/student-score-delete-by-session/academic-statuses', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getStudentClasses = (Options = {}) => {
  return httpClient
    .get('/api/student-score-delete-by-session/student-classes', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const get = (Options = {}) => {
  return httpClient
    .get('/api/student-score-delete-by-session', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getDeleteRecords = (Options = {}) => {
  return httpClient
    .get('/api/student-score-delete-by-session/delete-records', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = data => {
  return httpClient
    .delete('/api/student-score-delete-by-session', { data })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getStudents,
  getAcademicStatuses,
  getStudentClasses,
  get,
  getDeleteRecords,
  destroy
}
